import {
  Image,
  SimpleGrid,
  Container,
  Heading,
  Card,
  CardBody,
  Text,
  Flex,
  Box,
} from "@chakra-ui/react";
import ImgAi from "../images/ai.svg";
import ImgHealth from "../images/healthcare.svg";
import ImgERP from "../images/erp.svg";
import ImgMobApp from "../images/mobile.svg";

import { useRef } from "react";
import { useInView } from "framer-motion";

const ServicePage = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const ref1 = useRef(null);
  const isInView1 = useInView(ref1, { once: true });
  return (
    <Container
      maxW="container.xl"
      pt="4rem"
      id="services"
      justifyContent="center"
      px={8}
      css={{ scrollMargin: "4rem" }}
      ref={ref}
    >
      <Heading
        as="h1"
        size="3xl"
        noOfLines={4}
        bgGradient="linear(to-r, #7928CA, #FB3640)"
        bgClip="text"
        textAlign="center"
        pb={10}
        style={{
          transform: isInView ? "none" : "translateY(100px)",
          opacity: isInView ? 1 : 0,
          transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
        }}
      >
        Services
      </Heading>
      <SimpleGrid
        columns={{ base: 1, md: 2 }}
        spacing={10}
        data-cues="slideInUp"
        ref={ref1}
      >
        <Card
          p={5}
          boxShadow="md"
          style={{
            transform: isInView1 ? "none" : "translateX(-200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Heading py={5} as="h2" size="md" noOfLines={2} textAlign="center">
            Machine Learning and Artificial Intelligence
          </Heading>
          <CardBody>
            <Flex
              justifyContent="space-between"
              alignItems="center"
              direction={["column", "column", "row", "row"]}
              gap={10}
            >
              <Box flexBasis={["100%", "100%", "40%", "40%"]}>
                <Image src={ImgAi} alt="ZenSpyder Team" />
              </Box>
              <Box flexBasis={["100%", "100%", "60%", "60%"]}>
                <Text color="gray.500">
                  Unleash the power of AI to transform your business with
                  cutting-edge machine learning solutions that empower your
                  decision making witwh predictive insights from advanced AI
                  algorithms.Streamline your operations and increase efficiency
                  with the help of AI and ML technologies.
                </Text>
              </Box>
            </Flex>
          </CardBody>
        </Card>
        <Card
          p={5}
          boxShadow="md"
          style={{
            transform: isInView1 ? "none" : "translateX(200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Heading py={5} as="h2" size="md" noOfLines={2} textAlign="center">
            Enterprise Resource Planning (ERP)
          </Heading>
          <CardBody>
            <Flex
              justifyContent="space-between"
              alignItems="center"
              direction={["column", "column", "row", "row"]}
              gap={10}
            >
              <Box flexBasis={["100%", "100%", "40%", "40%"]}>
                <Image src={ImgERP} alt="ZenSpyder Team" />
              </Box>
              <Box flexBasis={["100%", "100%", "60%", "60%"]}>
                <Text color="gray.500">
                  Transform your business operations with our Enterprise
                  Resource Planning solution. Streamline processes, increase
                  efficiency, and drive growth. With real-time insights and
                  seamless integration, make informed decisions and achieve your
                  goals. Experience the power of ERP with us today.
                </Text>
              </Box>
            </Flex>
          </CardBody>
        </Card>
        <Card
          p={5}
          boxShadow="md"
          style={{
            transform: isInView1 ? "none" : "translateX(-200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Heading py={5} as="h2" size="md" noOfLines={2} textAlign="center">
            Healthcare Solutions
          </Heading>
          <CardBody>
            <Flex
              justifyContent="space-between"
              alignItems="center"
              direction={["column", "column", "row", "row"]}
              gap={10}
            >
              <Box flexBasis={["100%", "100%", "40%", "40%"]}>
                <Image src={ImgHealth} alt="ZenSpyder Team" />
              </Box>
              <Box flexBasis={["100%", "100%", "60%", "60%"]}>
                <Text color="gray.500">
                  Transform the way you manage your healthcare with our
                  cutting-edge software. Streamline operations, improve patient
                  outcomes, and enhance the overall experience. Say goodbye to
                  manual processes and hello to a smarter, more efficient
                  healthcare system. Choose us for the ultimate in healthcare
                  technology.
                </Text>
              </Box>
            </Flex>
          </CardBody>
        </Card>
        <Card
          p={5}
          boxShadow="md"
          style={{
            transform: isInView1 ? "none" : "translateX(200px)",
            opacity: isInView1 ? 1 : 0,
            transition: "all .6s cubic-bezier(0.17, 0.55, 0.55, 1) 0.5s",
          }}
        >
          <Heading py={5} as="h2" size="md" noOfLines={2} textAlign="center">
            Mobile App Development
          </Heading>
          <CardBody>
            <Flex
              justifyContent="space-between"
              alignItems="center"
              direction={["column", "column", "row", "row"]}
              gap={10}
            >
              <Box flexBasis={["100%", "100%", "40%", "40%"]}>
                <Image src={ImgMobApp} alt="ZenSpyder Team" />
              </Box>
              <Box flexBasis={["100%", "100%", "60%", "60%"]}>
                <Text color="gray.500">
                  Transform your vision into reality with our top-notch mobile
                  app development services. Experience seamless navigation,
                  cutting-edge features and superior performance. Our team of
                  experts will bring your ideas to life, delivering customized
                  solutions that meet your unique needs. Partner with us for a
                  smooth, efficient and successful app launch.
                </Text>
              </Box>
            </Flex>
          </CardBody>
        </Card>
      </SimpleGrid>
    </Container>
  );
};
export default ServicePage;
